namespace $.$$ {

	export class $shm_hitalama_map_widget_float_image extends $.$shm_hitalama_map_widget_float_image {

		@ $mol_mem
		blob_uri() {
			const blob = this.widget().Image()?.blob()
			if( !blob ) return null
			return this.$.$mol_blob_uri( blob )
		}

		@ $mol_mem
		image_uri(): string {
			this.widget().Image()?.blob()
			const uri = $mol_wire_sync( this ).blob_uri()
			return uri ?? ''
		}

		image_blob() {
			return this.widget().Image()?.blob() ?? null
		}

		image_file_name() {
			const blob = this.image_blob()
			const ext = blob?.type.split( '/' )[1]?.split( ';' )[0] || 'png'
			const title = this.title().trim().replace( /[\\/:*?"<>|]+/g, '_' ) || 'image'
			return `${ title }.${ ext }`
		}

		image_copy( next?: Event ) {
			if( next === undefined ) return null
			next.preventDefault()
			$mol_wire_async( this ).image_copy_later().catch( error => $mol_fail_log( error ) )
			this.Map_page().contextmenu_showed( false )
			return next
		}

		async image_copy_later() {
			const blob = this.image_blob()
			if( !blob ) return
			await this.$.$mol_dom_context.navigator.clipboard.write([
				new ClipboardItem({ [ blob.type || 'image/png' ]: blob }),
			])
		}

		@ $mol_mem
		ratio() {
			const img = this.Image()
			const height = img.natural_height()
			if( !height ) return 0
			return img.natural_width() / height
		}

	}

}
